import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Popover from '@material-ui/core/Popover';
import ErrorOutlineIcon from '@material-ui/icons/ErrorOutline';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(() => ({
  paper: {
    boxShadow: '1px 1px 5px #0000004D',
    borderRadius: '4px',
    opacity: 1,
  },
}));

function ErrorIconPopover({ children }) {
  const classes = useStyles();
  const [anchorEl, setAnchorEl] = useState(null);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);

  return (
    <>
      <ErrorOutlineIcon
        aria-owns={open ? 'tooltip' : undefined}
        onClick={(e) => {
          handleClick(e);
        }}
        aria-haspopup="true"
        style={{
          color: '#858888',
        }}
      />
      <Popover
        id="tooltip"
        classes={{ paper: classes.paper }}
        open={open}
        anchorEl={anchorEl}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
        onClose={handleClose}
        PaperProps={{ onMouseLeave: handleClose }}
      >
        {children}
      </Popover>
    </>
  );
}

ErrorIconPopover.propTypes = {
  children: PropTypes.node,
};

ErrorIconPopover.defaultProps = {
  children: null,
};

export default ErrorIconPopover;
